import React, { Component, Fragment } from 'react';
import { FieldArray, Field } from 'redux-form';
import PropTypes from 'prop-types';
import {
  FormGroup,
  Label,
  Button,
  Col,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';

class DynamicForm extends Component {
  constructor(props) {
    super(props);

    this.state = { rows: [] };
  }

  componentDidMount() {
    this.onMount();
  }

  onMount = () => {
    this.setState({ rows: this.props.initialValues });
  };

  onChangeComponent = (column, index, option) => {
    const rowValues = [...this.state.rows];
    const indexValue = rowValues[index] || {};
    const isEmptyOption =
      !option || (typeof option === 'string' && !option.trim());

    if (isEmptyOption) {
      const { [column.name]: removedValue, ...restValues } = indexValue;
      rowValues[index] = restValues;
    } else {
      // Get the row value state acoording to the event parent container
      rowValues[index] = {
        ...indexValue,
        [column.name]: option,
      };
    }

    this.setState({ rows: rowValues });

    column.onChange(index, option);
  };

  getValue = (column, index, fields) => {
    const row = fields.get(index);

    let value = null;

    if (row && row[column.dependentKey]) {
      value = row[column.dependentKey][column.name];

      if (column.Cell) value = column.Cell(value);
    }

    return value;
  };

  addNewFielGroup = (fields) => {
    const { onClickAdd } = this.props;

    const { rows } = this.state;
    const rowsState = [...rows, {}];
    this.setState({ rows: rowsState });

    if (onClickAdd) onClickAdd(fields);
    else fields.push({});
  };

  removeFieldGroup = (fields, index) => {
    const { onClickRemove } = this.props;

    const rowsState = [...this.state.rows];
    rowsState.splice(index, 1);
    this.setState({ rows: rowsState });

    if (onClickRemove) onClickRemove(index, fields);
    else fields.remove(index);
  };

  renderNestedFields = ({ fields, columns }) => {
    const { showSubRemoveButton, showSubAddButton, nestedTittle } = this.props;

    const fieldGroups = fields.map((fieldName, index) => {
      const rowValues = fields.get(index);
      const renderRemoveButton = showSubRemoveButton && (
        <Fragment>
          <Button
            type="button"
            color="danger"
            outline
            onClick={() => fields.remove(index)}
          >
            <i className="fa fa-minus-circle" /> Eliminar
          </Button>
        </Fragment>
      );

      const renderTitle = nestedTittle && (
        <h5>
          {nestedTittle} {index + 1}
        </h5>
      );

      return (
        <ListGroupItem
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          style={{ paddingLeft: 0, paddingRight: 0 }}
        >
          {renderTitle}
          <FormGroup row style={{ marginBottom: 0 }}>
            {this.renderField(
              columns,
              index,
              fieldName,
              rowValues,
              true,
              fields,
            )}
          </FormGroup>
          {renderRemoveButton}
        </ListGroupItem>
      );
    });

    const addButton = showSubAddButton ? (
      <Button
        type="button"
        color="primary"
        outline
        className="mt-2"
        onClick={() => fields.push({})}
      >
        <i className="fa fa-plus-circle" /> Agregar
      </Button>
    ) : null;

    return (
      <div className="mt-2 mb-4">
        <ListGroup flush>{fieldGroups}</ListGroup>
        {addButton}
      </div>
    );
  };

  renderField = (
    columns,
    index,
    fielName,
    rowValues,
    isNested = false,
    fields,
  ) =>
    columns.map((column) => {
      if (typeof column.hidden === 'function' && column.hidden(rowValues)) {
        return null;
      }

      // Render fields without label and component
      if (column.customizedField) {
        let customizedField = null;

        if (column.customizedField === 'button') {
          const click = column.onClick ? () => column.onClick(index) : null;

          customizedField = (
            <Button
              type="button"
              onClick={click}
              outline
              className={column.class}
            >
              {column.label}
            </Button>
          );
        }

        if (column.customizedField === 'custom' && column.render) {
          customizedField = column.render(index, rowValues);
        }

        return (
          <Col
            key={`col${column.name}${index.toString()}`}
            lg={column.lg}
            md={column.md}
            sm={column.sm}
            className="mb-2"
          >
            <Label>&nbsp;</Label>
            <div>{customizedField}</div>
          </Col>
        );
      }

      // Render dependent fields
      if (column.dependentKey) {
        return (
          <Col
            key={`col${column.name}${index.toString()}`}
            lg={column.lg}
            md={column.md}
            sm={column.sm}
            className="mb-2"
          >
            <Label for={column.name}>{column.label}</Label>
            <div
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              className="form-control disabled"
            >
              {this.getValue(column, index, fields)}
            </div>
          </Col>
        );
      }

      // Render fields with ArrayColumns
      if (column.isFieldArray && !isNested) {
        return (
          <Col
            key={`col${column.name}${index.toString()}`}
            lg={column.lg}
            md={column.md}
            sm={column.sm}
            className="mb-2"
          >
            <Label>{column.label}</Label>
            <FieldArray
              name={`${fielName}.${column.name}`}
              component={this.renderNestedFields}
              columns={column.fields}
            />
          </Col>
        );
      }

      const otherProps = { ...column.otherProps };
      if (otherProps) {
        Object.keys(otherProps).forEach((key) => {
          if (typeof otherProps[key] === 'function') {
            otherProps[key] = otherProps[key](rowValues);
          }
        });
      }

      // Set props of component fields
      const props = {
        name: `${fielName}.${column.name}`,
        component: column.component,
        ...otherProps,
      };
      if (column.type) props.type = column.type;
      if (column.placeholder) props.placeholder = column.placeholder;
      if (column.validate) props.validate = column.validate;
      if (column.onChange)
        props.onChange = (option) =>
          this.onChangeComponent(column, index, option);

      if (column.noOptionsMessage)
        props.noOptionsMessage = ({ inputValue }) =>
          column.noOptionsMessage(index, inputValue);

      if (typeof column.disabled === 'function') {
        props.disabled = column.disabled(rowValues);
      } else if (column.disabled !== undefined) {
        props.disabled = column.disabled;
      }
      const requiredLabel = column.requiredLabel ? (
        <span className="text-danger">*</span>
      ) : null;

      // Render component fields
      return (
        <Col
          key={`col${column.name}${index.toString()}`}
          lg={column.lg}
          md={column.md}
          sm={column.sm}
          className="mb-2"
        >
          <Label for={column.name}>
            {column.label} {requiredLabel}
          </Label>
          <Field {...props} />
        </Col>
      );
    });

  renderFieldGroups = (
    columns,
    fields,
    title,
    showRemoveButton,
    otherButtonsPerRow,
    labelWithoutElements,
  ) => {
    let fieldGroup = <>{labelWithoutElements}</>;

    if (fields.length > 0) {
      fieldGroup = fields.map((fielName, index) => {
        const rowValues = fields.get(index);
        let renderOtherButtonsPerRow = null;

        if (otherButtonsPerRow) {
          renderOtherButtonsPerRow = otherButtonsPerRow.map(
            (button, buttonIndex) => (
              <Button
                key={`otherButtons${buttonIndex.toString()}`}
                color={button.color}
                outline
                onClick={() => button.onClick(index)}
              >
                {button.icon && <i className={button.icon} />} {button.label}
              </Button>
            ),
          );
        }

        const canRemove =
          typeof showRemoveButton === 'function'
            ? showRemoveButton(rowValues, index)
            : showRemoveButton;

        const renderRemoveButton = canRemove && (
          <Fragment>
            <Button
              type="button"
              color="danger"
              outline
              onClick={() => this.removeFieldGroup(fields, index)}
              onKeyPress={() => this.removeFieldGroup(fields, index)}
            >
              <i className="fa fa-minus-circle" /> Eliminar
            </Button>{' '}
            {renderOtherButtonsPerRow}
          </Fragment>
        );

        const renderTitle = title && (
          <h5>
            {title} {index + 1}
          </h5>
        );

        return (
          <ListGroupItem
          key={
            // eslint-disable-next-line
            rowValues && rowValues._rowId
            // eslint-disable-next-line
                ? rowValues._rowId
                : +index.toString()
            }
            style={{ paddingLeft: 0, paddingRight: 0 }}
          >
            {renderTitle}
            <FormGroup row style={{ marginBottom: 0 }}>
              {this.renderField(
                columns,
                index,
                fielName,
                rowValues,
                false,
                fields,
              )}
            </FormGroup>
            {renderRemoveButton}
          </ListGroupItem>
        );
      });
    }

    return fieldGroup;
  };

  renderDynamicForm = ({ fields, columns, showAddButton }) => {
    const {
      // columns,
      showRemoveButton,
      title,
      otherButtonsPerRow,
      // showAddButton,
      labelWithoutElements,
      extraActions,
    } = this.props;

    const fieldGroups = this.renderFieldGroups(
      columns,
      fields,
      title,
      showRemoveButton,
      otherButtonsPerRow,
      labelWithoutElements,
    );

    const addButton = showAddButton ? (
      <Button
        type="button"
        color="primary"
        outline
        className="mt-2"
        onClick={() => this.addNewFielGroup(fields)}
      >
        <i className="fa fa-plus-circle" /> Agregar
      </Button>
    ) : null;

    const extraButtons = extraActions
      ? extraActions.map((action, i) => (
          <Button
            // eslint-disable-next-line react/no-array-index-key
            key={`extraAction${i}`}
            type="button"
            color={action.color || 'secondary'}
            outline
            className="mt-2 ml-2"
            onClick={() => action.onClick(fields)}
          >
            {action.icon && <i className={action.icon} />} {action.label}
          </Button>
        ))
      : null;

    return (
      <div className="mt-2 mb-4">
        <ListGroup flush>{fieldGroups}</ListGroup>
        {addButton} {extraButtons}
      </div>
    );
  };

  render() {
    // const { name } = this.props;

    const { name, columns, showAddButton } = this.props;

    // return <FieldArray name={name} component={this.renderDynamicForm} />;
    return (
      <FieldArray
        name={name}
        component={this.renderDynamicForm}
        columns={columns}
        showAddButton={showAddButton}
      />
    );
  }
}

DynamicForm.propTypes = {
  name: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      lg: PropTypes.number,
      md: PropTypes.number,
      sm: PropTypes.number,
      label: PropTypes.string,
      component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
      name: PropTypes.string,
      type: PropTypes.string,
      placeholder: PropTypes.string,
      validate: PropTypes.arrayOf(PropTypes.func),
      dependentKey: PropTypes.string,
      Cell: PropTypes.func,
      isFieldArray: PropTypes.bool,
    }),
  ).isRequired,
  onClickRemove: PropTypes.func,
  onClickAdd: PropTypes.func,
  showRemoveButton: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  showAddButton: PropTypes.bool,
  title: PropTypes.string,
  nestedTittle: PropTypes.string,
  otherButtonsPerRow: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      color: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ),
  // eslint-disable-next-line react/forbid-prop-types
  initialValues: PropTypes.arrayOf(PropTypes.object),
  labelWithoutElements: PropTypes.string,
  showSubRemoveButton: PropTypes.bool,
  showSubAddButton: PropTypes.bool,
  extraActions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      color: PropTypes.string,
      icon: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ),
};

DynamicForm.defaultProps = {
  onClickRemove: null,
  onClickAdd: null,
  showRemoveButton: true,
  showAddButton: true,
  title: null,
  nestedTittle: null,
  otherButtonsPerRow: [],
  initialValues: [],
  labelWithoutElements: 'No hay elementos',
  showSubRemoveButton: true,
  showSubAddButton: true,
  extraActions: [],
};

export default DynamicForm;
